<template>
  <customModal :containersm="true" @closeModal="closeAssignModal()">
    <template #title>
      {{ $t("navigations.resolve alert") }}
    </template>
    <template #body>
      <div class="py-2">
      <label for="resolveReason">{{ $t('navigations.reason for resolve') }}</label>
      <select class="form-select mb-2" name="reason to resolve" id="resolveReason" v-model="resolveReason">
        <option v-for="reason in resolveReasons" :key="reason.status" :value="reason.status">{{ reason.status }}</option>
      </select>
      <label for="alertComments">{{ $t("navigations.comments") }}</label>
      <textarea name="comments" placeholder="Enter comments" v-model="comments" id="alertComments"></textarea>
      <div class="text-center py-2">
          <button
        class="btn btn-primary btn-sm py-0 px-3 mt-2"
        @click.prevent="saveComments()"
      >
        {{ $t("navigations.save") }}
      </button>
      </div>
      </div>
    </template>
  </customModal>
</template>
<script src="./AlertStatusPopup.js">
</script>
<style scoped>
</style>